import Skeleton from "./Skeleton";

export default function TableLoadingSkeleton() {
  return (
    <div>
      <div className="grid grid-cols-4 gap-9 p-3">
        {[1, 2, 3, 4].map((_, i) => (
          <Skeleton key={i} size="xs" />
        ))}
      </div>
      {[...Array(8).keys()].map((_, i) => (
        <div key={i} className="grid grid-cols-4 gap-9 p-3">
          {[1, 2, 3, 4].map((_, i) => (
            <div key={i} className="flex flex-1 flex-col gap-1">
              <Skeleton size="xs" className="w-28" />
              <Skeleton size="xs" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
